import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed, Subscribable, SubscribableOrNullableValue, SubscribableOrValue } from 'knockout';
import device from 'managers/device';
import './mediaPickerDialog.html';
import './mediaPickerDialog.scss';

components.preload('progress-ring');

const { availableViewportSizeToOverlay } = settings;

export interface MediaPickerDialogConfig {
    items: SubscribableOrNullableValue<Array<MediaPickerDialogItem>>
    task?: SubscribableOrNullableValue<MediaPickerDialogTask>
    ready?: SubscribableOrNullableValue<boolean>
}

export interface MediaPickerDialogItem {
    title: SubscribableOrValue<string>
    icon?: SubscribableOrValue<string>
    image?: SubscribableOrValue<string>

    onClick: Action
}

export interface MediaPickerDialogTask {
    title: SubscribableOrNullableValue<string>
    progress: SubscribableOrValue<number>
}

@injectable()
export default class WCCMediaPickerVM {
    items: Subscribable<Array<MediaPickerDialogItem>>
    task: Subscribable<MediaPickerDialogTask | undefined>

    isReady: Subscribable<boolean>
    isBodyShown: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: MediaPickerDialogConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.items = ko.flattenComputed(config.items, []);
        this.task = ko.flattenComputed(config.task);

        this.isReady = ko.flattenComputed(config.ready, true);
        this.isBodyShown = ko.pureComputed(() => this.task() == undefined);

        const maxWidth = ko.pureComputed(() => device.width() * availableViewportSizeToOverlay);
        const maxHeight = ko.pureComputed(() => device.height() * availableViewportSizeToOverlay);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'media-picker-dialog': true
            },

            'style': {
                'max-width': maxWidth.toPx(),
                'max-height': maxHeight.toPx()
            }
        });
    }
}